import { NodeViewContent, NodeViewWrapper, type NodeViewProps } from '@tiptap/react'

const TYPES = ['note', 'tip', 'warning', 'danger', 'info'] as const
const LABEL: Record<string, string> = {
  note: 'Note',
  tip: 'Tip',
  info: 'Note',
  warning: 'Warning',
  danger: 'Danger',
}

/**
 * A callout. The type is a control on the block itself rather than a property in
 * a side panel: it changes how the block reads, so it belongs where the block is.
 *
 * `null` means the author wrote `:::hint` with no attribute, which the model
 * preserves — so "Default" is a real option here, not the same as picking note.
 */
export function HintView({ node, updateAttributes, editor }: NodeViewProps) {
  const type = (node.attrs['type'] as string | null) ?? 'note'
  return (
    <NodeViewWrapper className={`be-hint be-hint--${type}`} data-sls="hint">
      <div className="be-hint__bar" contentEditable={false}>
        <span className="be-hint__label">{LABEL[type] ?? 'Note'}</span>
        {editor.isEditable && (
          <select
            className="be-select"
            value={(node.attrs['type'] as string | null) ?? ''}
            onChange={(e) => updateAttributes({ type: e.target.value || null })}
          >
            <option value="">Default (note)</option>
            {TYPES.map((t) => (
              <option key={t} value={t}>
                {t}
              </option>
            ))}
          </select>
        )}
      </div>
      <NodeViewContent className="be-hint__body" />
    </NodeViewWrapper>
  )
}
